import { isEqual } from "lodash";
import { AioIconButton } from "../additional/aioIconButton";
import { getBaseId } from "./functions/getBaseId";
import {
  AitLocationBodyRowGroup,
  AitLocationHeader,
  AitTablePosition,
  HIDE_OPTIONS_WINDOW,
  SHOW_OPTIONS_WINDOW,
} from "./functions/interface";
import { useTableContext } from "./TableContextProvider";

interface AitRowGroupOptionsButtonProps {
  location: AitLocationHeader | AitLocationBodyRowGroup;
}

/**
 * Button to toggle the row-group options window.
 *
 * @param props - Component props
 * @param props.location - The header or body row-group location
 */
export const AitRowGroupOptionsButton = ({ location }: AitRowGroupOptionsButtonProps) => {
  const { state, dispatch } = useTableContext();
  const id = getBaseId(location, state?.id);

  return (
    <AioIconButton
      id={`${id}-rowgroup-options`}
      tipText={
        location.position === AitTablePosition.header ? "Header options" : "Row group options"
      }
      iconName="aioxButtonRowGroup"
      onClick={() => {
        dispatch({
          operation:
            state?.showOptionsWindow.findIndex((l) => isEqual(l, location)) === -1
              ? SHOW_OPTIONS_WINDOW
              : HIDE_OPTIONS_WINDOW,
          location,
        });
      }}
    />
  );
};

AitRowGroupOptionsButton.displayName = "AitRowGroupOptionsButton";
